// root '../../../';

// dependencies
import { Child } from 'pym.js';
// import { select } from 'd3-selection';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import { stylePremium } from './utils/helpers';
// import config from './config';
// import graphic from './graphic';

// styles
import './styles/index.scss';
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';
import data from './data/data.json';

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

function applyHeadline() {
  const node = document.querySelector('#meta .headline');

  if (node && meta.headline) {
    node.innerHTML = meta.headline;
  }
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw });

applyHeadline();

window.onload = () => {
  applyHeadline();

  const { pymChild } = window;
  // delay the initial resizing to give Twitter time to render tweets
  setTimeout(() => { pymChild.sendHeight(); }, 250);
  window.dispatchEvent(new Event('resize'));
};

stylePremium(false, false);

function draw() {
  window.dispatchEvent(new Event('resize'));
}


data.forEach((item, index) => {
  item.id = index;
});

const groupedByTime = data.reduce((acc, item) => {
  acc[item.time] = acc[item.time] || [];
  acc[item.time].push(item);
  return acc;
}, {});

// Convert to nested JSON structure with each time as its own object
const nestedTimeData = Object.entries(groupedByTime).map(([time, items]) => ({
  time,
  items,
}));

console.log('Grouped by time:', groupedByTime);
console.log('Nested JSON structure:', nestedTimeData);

// Add in the container for the timeline
const container = document.getElementById('graphic');
container.innerHTML = '';

// Add in the timeline entries
nestedTimeData.forEach(({ time, items }) => {
  // Add in the timeline entry date header
  const timelineEntry = container.appendChild(document.createElement('div'));
  timelineEntry.className = 'timeline-entry';
  const date = timelineEntry.appendChild(document.createElement('h3'));
  date.className = `timeline-date ${items[0].addedClasses ? items[0].addedClasses : ''}`;
  date.innerHTML = time.replace('#', '');

  // Add in each timeline entry content item
  items.forEach((item) => {
    const content = timelineEntry.appendChild(document.createElement('div'));
    content.className = `timeline-content ${item.addedClasses ? item.addedClasses : ''}`;

    // Add in the timeline entry content item based on the class
    switch (item.class) {
      case 'text':
        // Add in text entry with line breaks
        content.innerHTML = `<p>${(item.text).replace(/\n/g, '<br>')}</p>`;
        break;
      case 'video':
        // Add in video entry with autoplay or controls
        content.innerHTML = `<figure><video src="${item.src}" ${item.autoplay ? 'autoplay muted loop playsinline webkit-playsinline' : 'controls'}>
                                <source type="video/mp4">
                            </video></figure> 
                        <figcaption>Credit: ${item.credit}  </figcaption>`;
        break;
      case 'photo':
        // Add in photo entry with credit
        if (item.addedClasses && item.addedClasses.includes('inset')) {
          content.innerHTML = `<div class="inset">
                                <figure><img src="${item.src}" /></figure>
                                <figcaption>Credit: ${item.credit}</figcaption>
                              </div>`;
          // If there's text, add it AFTER the inset div so it wraps around
          if (item.text) {
            content.innerHTML += `<p class="inset-text">${(item.text).replace(/\n/g, '<br>')}</p>`;
          }
        } else {
          content.innerHTML = `<figure><img src="${item.src}" class="${item.addedClasses ? item.addedClasses : ''}"/></figure>
                                <figcaption>Credit: ${item.credit}</figcaption>`;
          if (item.text) {
            content.innerHTML += `<p>${(item.text).replace(/\n/g, '<br>')}</p>`;
          }
        }
        break;
      case 'graphic':
        // Add in rig graphic
        content.innerHTML = `<div id="responsive-embed-${item.src}" data-type="dailygraphics" data-slug="${item.src}" data-url="https://ix.cnn.io/dailygraphics/graphics/${item.src}/index.html"></div>`;

        if (!window.pym) {
          (function (b, c) { const d = document.createElement('script'); d.type = 'text/javascript', d.readyState ? d.onreadystatechange = function () { (d.readyState === 'loaded' || d.readyState === 'complete') && (d.onreadystatechange = null, c()); } : d.onload = function () { c(); }, d.src = b, document.getElementsByTagName('head')[0].appendChild(d); }('//cdn.cnn.com/cnn/.e/interactive/js/lib/vendor/pym/pym.v1.min.js', () => { new pym.Parent(`responsive-embed-${item.src}`, `//ix.cnn.io/dailygraphics/graphics/${item.src}/index.html`, { title: 'CNN Graphic' }); }));
        } else var responsiveEmbed = new pym.Parent(`responsive-embed-${item.src}`, `//ix.cnn.io/dailygraphics/graphics/${item.src}/index.html`, { title: 'CNN Graphic' });
        break;
      default:
        // Add in default entry
        content.innerHTML = '<p>No content available</p>';
        break;
    }
  });
});
